import { useEffect, useState } from 'react';

type Options = {
  resetStateTimer?: number;
};
const useCopyToClipboard = (options?: Options) => {
  const [isCopied, setIsCopied] = useState(false);

  useEffect(() => {
    let timer: NodeJS.Timeout;
    if (options?.resetStateTimer && options.resetStateTimer > 0) {
      timer = setTimeout(() => {
        setIsCopied(false);
      }, options.resetStateTimer);
    }

    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [isCopied]);

  const copyToClipboard = async (content) => {
    try {
      await navigator.clipboard.writeText(content);
      setIsCopied(true);
    } catch (error) {
      setIsCopied(false);
    }
  };

  return { isCopied, copyToClipboard };
};

export default useCopyToClipboard;
